import { ILog, IHistorical } from '../../../models';

export const HistoryPageSize = 10;

export type IDownloadLogData = {
  username: string;
  deviceCount: number;
};
export type DownloadLog = ILog & IDownloadLogData;

export type DownloadHistory = IHistorical<DownloadLog>;

export interface State {
  historical: DownloadHistory
}
